var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"target",class:[
    _vm.$style.container,
    !_vm.currentInSlider ? _vm.$style.containerNoPadding : _vm.$style.containerPadding
  ],on:{"mousemove":_vm.handleMouseMove}},[_c('p',{ref:"text",class:_vm.$style.text,attrs:{"data-anim":!_vm.isInView ? 'fade' : false,"data-anim-enter":"fade"},domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94565d72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GradientText.vue
// module id = null
// module chunks = 